import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';
import type { LoginAnalyticsResponse } from 'src/types/loginAnalytics';

export type { LoginAnalyticsResponse } from 'src/types/loginAnalytics';

export default class LoginAnalyticsService extends AbstractApiService {
  public constructor() {
    super({});
  }

  /**
   * Get organization-wide login analytics
   *
   * @param startDate - Start date in YYYY-MM-DD format
   * @param endDate - End date in YYYY-MM-DD format
   * @param includeFailures - Include failed login attempts in the count
   * @returns Promise with login analytics response
   *
   * @example
   * ```typescript
   * const analytics = await loginAnalyticsService.getLoginAnalytics('2025-12-01', '2025-12-17');
   * console.log(analytics.summary.total_logins);
   * ```
   */
  public async getLoginAnalytics(
    startDate: string,
    endDate: string,
    includeFailures = false,
  ): Promise<LoginAnalyticsResponse> {
    const queryParams = new URLSearchParams();

    queryParams.append('start_date', startDate);
    queryParams.append('end_date', endDate);

    if (includeFailures) {
      queryParams.append('include_failures', 'true');
    }

    const queryString = queryParams.toString();
    const endpoint = `${api.get_login_analytics}?${queryString}`;

    return await this.getWithoutOrgId(endpoint);
  }
}
